module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/back-speed-page-5af0d052b2b2c89400f82f5ae7bcddad.jpg";